import fetcher from './fetchers'

/**
 * 获取壁纸大赛配置
 * @returns {Promise<{ periods: object[], server_time: number }>}
 */
export function getContestConfigs() {
  return fetcher.post('/wallpaper/contest/configs')
}

/**
 * 获取当前时间的比赛配置
 * @returns {Promise<{ contest_intro_url: string, contest_name: string, contest_tag_name: string }?>}
 */
export async function getCurrentContestConfig() {
  const res = await getContestConfigs()
  if (!res.periods) return null
  // 找到第一个投稿结束时间大于当前时间的比赛
  let index = -1
  const founded = res.periods.some((contest, i) => {
    if (contest.start_upload_time <= res.server_time && contest.finish_upload_time > res.server_time) {
      index = i
      return true
    }
    return false
  })
  return founded ? res.periods[index] : null
}
